import React from "react";
import CustomText from "./CustomText";
import Colors from "../config/Colors";
import MatchCard from "./cards/MatchCard";
import CardArrow from "./CardArrow";
import HeaderDropdown from "./HeaderDropdown";
import { IPLTeamLogos, mapAbbrToLogo } from "../types/type";
import Currency from "../config/Currency";

export interface MatchType {
  match_mid: number;
  away_team_abbreviation: string;
  home_team_abbreviation: string;
  start_time: string;
  is_played?: boolean;
  home_team_logo_url: string;
  away_team_logo_url: string;
}

interface HeaderDropdownProps {
  children?: React.ReactNode;
  vs?: boolean;
  onChoose?: (match: MatchType) => void;
  matches?: Array<MatchType>;
  amount?: string | number;
}

function MatchHeaderDropdown({
  children,
  vs,
  onChoose,
  matches,
  amount,
}: HeaderDropdownProps) {
  const handleChoose = (match: any) => {
    if (onChoose) {
      onChoose(match);
    }
  };

  return (
    <HeaderDropdown>
      <div className="containerMatchHeaderDropdownContainer">
        <div className="containerMatchHeaderDropdownWeelyPrizesTop">
          <CustomText
            spacing={4}
            size="medium"
            weight="400"
            color={Colors.blueGray}
            marginBottom={10}
            marginTop={30}
          >
            Total Prizes
          </CustomText>
        </div>
        <CustomText weight="900" size="prize" className="textMatchPrizeText">
          {Currency.rupee}
          {amount}
        </CustomText>
        <div className="containerMatchHeaderDropdownWeelyPrizesBottom">
          <CustomText
            spacing={4}
            size="medium"
            weight="400"
            // color={Colors.blueGray}
            marginBottom={10}
            marginTop={10}
            className="textMatchPrizeTextWeeklyPrize"
          >
            Total Prizes
          </CustomText>
        </div>
      </div>
    </HeaderDropdown>
  );
}

export default MatchHeaderDropdown;
